import type { FC } from "react";

import { SWReactIcons } from "@similarweb/icons";

import type { IDropDownItem } from "@similarweb/ui-components";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { IRegionObject } from "app/services/RegionService";

import {
    StyledDDContent,
    StyledDDItemContainer,
    StyledLockedIcon,
    StyledLockedIconContainer,
    StyledMainContainer,
    StyledRegionDDText,
    StyledRegionIconWrapper,
} from "./styles";

type RegionDropdownItemProps = {
    region: IRegionObject | (IDropDownItem & { name?: string; isLastPermitted?: boolean });
    isPermitted: boolean;
    iconName?: string;
    width?: number;
};
const RegionDropdownItem: FC<RegionDropdownItemProps> = ({ region, isPermitted, width, iconName }) => {
    const { name } = region;
    return (
        <StyledDDItemContainer width={width}>
            {iconName ? (
                <StyledRegionIconWrapper>
                    <SWReactIcons
                        iconName={"location-circled"}
                        size="sm"
                    />
                </StyledRegionIconWrapper>
            ) : null}

            <StyledDDContent>
                <StyledMainContainer>
                    <I18n
                        translatable={{ key: `si.common.region.${name}.label` }}
                        element={StyledRegionDDText}
                    />
                </StyledMainContainer>
                {!isPermitted ? (
                    <StyledLockedIconContainer>
                        <StyledLockedIcon
                            iconName="locked"
                            size="xs"
                        />
                    </StyledLockedIconContainer>
                ) : null}
            </StyledDDContent>
        </StyledDDItemContainer>
    );
};

export default RegionDropdownItem;
